import { MasterHelper } from '../../utilities';

export class RulebookModel {
    id: number;
    libraryName: string;
    ruleBook: string;
    regulator: string;
    geography: string;
    country: string;
    effectiveDate: Date;
    title: string;
    part: string;
    title1: string;
    title2: string;
    title3: string;
    title4: string;
    title5: string;
    ruleId: string;
    regulatorRuleFullRequirement: string;
    hyperlink: string;
    spiderLinks: string;
    relatedProvisions: string;
    insertedRow: number;
    editableRow: number;
    version: number;
    parentId: number;
    applicable: boolean;
    isRead: boolean;
    operative: boolean;
    policyName: string;
    owner: string;

    constructor() {
        this.id = 0;
        this.libraryName = '';
        this.ruleBook = '';
        this.regulator = '';
        this.geography = '';
        this.country = '';
        this.effectiveDate = MasterHelper.getDate(0);
        this.title = '';
        this.part = '';
        this.title1 = '';
        this.title2 = '';
        this.title3 = '';
        this.title4 = '';
        this.title5 = '';
        this.ruleId = '';
        this.regulatorRuleFullRequirement = '';
        this.hyperlink = '';
        this.spiderLinks = '';
        this.relatedProvisions = '';
        this.insertedRow = 0;
        this.editableRow = 0;
        this.version = 0;
        this.parentId = 0;
        this.applicable = false;
        this.isRead = true;
        this.operative = false;
        this.policyName='';
        this.owner='';
    }
}

export class RulebookViewModel {
    data: RulebookModel[];
    totalCount: number;

    constructor() {
        this.data = new Array<RulebookModel>();
        this.totalCount = 0;
    }
}

export class RulebookFilter {
    SortKey: string | null;
    IsDesc: boolean | true;
    TakeCount: number | null;
    SkipCount: number | null;
    TotalItems: number | null;

    constructor() {
        this.SortKey = null;
        this.IsDesc = true;
        this.TakeCount = null;
        this.SkipCount = null;
        this.TotalItems = null;
    }
}

export class setSummaryDetails{
    id:number;
    type:string;
    rulebookId:number;
    constructor() {
        this.id = 0;
        this.type = "";
        this.rulebookId = 0;
    }
}

export enum RuleTypeName {
    Unknown = 0,
    GDPR = 1,
    CRR = 2,
    APAC = 3,
    CRAR = 4
}
